/** Durées de rétention des commandes/simulations par tenant (jours). */
export const ORDER_STORAGE_DAYS = {
  mortar: 365,
  but: 365,
  conforama_retail: 365,
  retail_it: 30,
  retail_fnac_pt: 60,
  mediamarkt_nl: 30,
  mediamarkt_be: 30
}

const DEFAULT_ORDER_STORAGE_DAYS = 365

export function getOrderStorageDays(tenant) {
  return ORDER_STORAGE_DAYS[tenant] ?? DEFAULT_ORDER_STORAGE_DAYS
}
